<template>
  <div class="modal-overlay">
    <div class="modal-background" @click="$emit('close')" />
    <div class="modal">
      <div class="title-close">
        <h1 class="modal-title">{{ $adminT('navigation.scanner_code_heading', 'Scanner code') }}</h1>
        <span class="material-icons" @click="$emit('close')"> close </span>
      </div>
      <div class="description">
        {{ $adminT('navigation.scanner_instructions', 'Copy this code to the CoreEvent Scanner mobile app to give scanner access to the individuals validating tickets or accreditations for this event.') }}
      </div>
      <div class="download-container">
        <div style="display: flex; gap: 1rem; align-items: center">
          <div class="download-container__logo">
            <img src="/assets/sidebar-icons/sidebar-header/scanner-app-logo.svg" alt="CoreEvent scanner" style="width:2.33331rem; height: 2.33331rem">
          </div>
          <div class="download-container__header">
            <h2 class="download-container__header-title">{{ $adminT('navigation.coreevent_scanner_mobile_app', 'CoreEvent Scanner mobile app') }}</h2>
            <h3 class="download-container__header-subtitle">{{ $adminT('navigation.download_the_app_here', 'Download the app here:') }}</h3>
          </div>
        </div>
        <div class="links-container">
          <a href="https://apps.apple.com/hr/app/coreevent-scanner/id1528492456" target="_blank">
            <img src="/assets/sidebar-icons/sidebar-header/app-store-link.svg" alt="App store">
          </a>
          <a href="https://play.google.com/store/apps/details?id=co.core_event.scanner" target="_blank">
            <img src="/assets/sidebar-icons/sidebar-header/google-play-link.svg" alt="Google play store">
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'scanner-code-modal',
}
</script>
<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.modal-background {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #00000050;
}
.modal {
  text-align: left;
  background-color: white;
  width: 100%;
  position: relative;
  max-width: 34rem;
  padding: 2rem;
  border-radius: 20px;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.modal::-webkit-scrollbar {
  display: none;
}
.modal-title {
  color: #0277bd;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.0375rem;
}
@media screen and (max-width: 700px) {
  .modal {
    width: 100%;
    max-width: 100%;
    height: 100%;
    border-radius: 0;
  }
}
.title-close {
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.material-icons {
  cursor: pointer;
}
.description {
  color: #979797;
  font-family: Source Sans Pro;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}
.download-container {
  display: flex;
  padding: 1.5rem;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 1rem;
  align-self: stretch;
  border-radius: 2rem;
  border: 1px solid #E6F1F8;
  background: #F0F6FA;
}

.download-container__logo {
  padding: 0.58331rem 0.58331rem 0.4rem 0.58331rem;
  border-radius: 1rem;
  border: 0.583px solid #E6F1F8;
  background: #FFF;
}

.download-container__header-title {
  color: #0277BD;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.045rem;
}

.download-container__header-subtitle {
  color: #0277BD;
  font-family: "Source Sans Pro";
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

.links-container {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}
</style>
